import React, {ComponentType, ElementType, FC, PropsWithChildren} from 'react';

interface Props {
	as?: ComponentType | ElementType;
	statement: boolean;
}

export type ConditionallyVisibleProps = PropsWithChildren<Props>;

export const ConditionallyVisible: FC<ConditionallyVisibleProps> = React.memo(
	({as = React.Fragment, statement, children, ...props}) => {
		const Component = as;

		return statement ? <Component {...props}>{children}</Component> : null;
	},
);
